import { inject, Pipe, PipeTransform } from '@angular/core';
import { FileService } from '../services/file.service';
import { FileMapEntry, Resource } from 'common';

/**
 * Fetch a file (resource) binary from the server. 
 */
@Pipe({
    name: 'libLoadFile',
    standalone: true
})
export class FileLoaderPipe implements PipeTransform {

    private fileService = inject(FileService);

    public transform(file: Resource | FileMapEntry) {

        if (!file) return null;

        if (this.isResource(file))
            return this.fileService.convertServerUrlToLocalUrl(file.contentUrl, file.contentType)
                .then((localUrl) => {
                    return localUrl || null;
                }).catch((error) => {
                    console.error('Error loading file:', error);
                    return null;
                });

        else return this.fileService.convertServerUrlToLocalUrl((file.serverUrl || file.localUrl), file.type)
            .then((localUrl) => {
                return localUrl || null;
            }).catch((error) => {
                console.error('Error loading file:', error);
                return null;
            });

    }

    private isResource(file: any): file is Resource {
        return file && file.contentUrl;
    }

}
